export const DescriptionUnknownError =
  "Por favor, inténtalo nuevamente. Si el error persiste, comunícate con soporte.";

export const DownloadFileErrorMessage = Object.freeze({
  title: "No se pudo descargar el archivo",
  description: DescriptionUnknownError,
});

export const DownloadFileSuccessMessage = Object.freeze({
  title: "Archivo descargado",
});

export const DeleteErrorMessage = Object.freeze({
  description: DescriptionUnknownError,
});

export const SaveSuccessTitle = "Cambios guardados";

export const SaveErrorMessage = Object.freeze({
  title: "No se pudieron guardar los cambios",
  description: DescriptionUnknownError,
});

/**
 * Toast utilizado para cuando hay errores de validaciones en el formulario y el usuario sigue itentando guardar los cambios sin corregir los errores.
 */
export const SaveErrorInvalidClientValidation = Object.freeze({
  title: "No se pudieron guardar los cambios",
  description: "Revisa los campos requeridos",
});
